import { useMutation } from '@tanstack/react-query';
import { UniversalSearchRequest } from 'src/generated/services/TFinancialApi';
import { tFinancialService } from 'src/infra/services/tFinancialService';

// TODO: Need BE return isUnderReview in the search result for showing the invoice StatusChip
export const useGeneralSearch = () => useMutation((data: UniversalSearchRequest) => tFinancialService.api.performUniversalSearch(data));
